import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import jwt_decode from 'jwt-decode'

type AuthProviderProps = {
  children: ReactNode;
};

type AuthContextProps = {
  user: any;
  handleLogin: (session: any) => void;
  handleLogout: () => void;
};

export const AuthContext = createContext({} as AuthContextProps);

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState(null);
  const history = useHistory()

  const handleLogout = useCallback(() => {
    localStorage.removeItem("session");
    setUser(null);
    window.location.replace(
      String(process.env.REACT_APP_LOGIN_URL) + "/logout"
    );
  }, []);

  const handleLogin = useCallback((session: any) => {
    const decoded: {exp: number, id: string} = jwt_decode(session.tk + "");
    if (decoded.id !== session.i) {
      return "Algo deu errado ao tentar fazer o login, tente novamente."
    }
    const withExp = {...session, exp: decoded.exp}
    localStorage.setItem("session", JSON.stringify(withExp));
    setUser(withExp);
    history.push('/')
  }, [history]);

  useEffect(() => {
    try {
      const session = JSON.parse(localStorage.getItem("session") || "");
      if (session.exp) {
        if (session.exp >= Date.now()) {
          window.location.replace(String(process.env.REACT_APP_LOGIN_URL) + '/expired')
        }
      }
      if (!!session) handleLogin(session);
    } catch (err) {
      
    }
  }, [handleLogin]);

  return (
    <AuthContext.Provider
      value={{
        user,
        handleLogout,
        handleLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
